var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.meta.headerMenu)?_c('HeaderMenu'):_vm._e(),_c('router-view'),(_vm.$route.name === 'home')?_c('HeaderNotification'):_vm._e(),(_vm.$route.name === 'transaction-sell')?_c('AddSellButton'):_vm._e(),(_vm.$route.meta.bottomMenu)?_c('BottomMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }